// Keep in sync with packages/www-ricos/src/utils/font-family.ts
export const WIXEL_FONT_FALLBACK = 'rubik-v2';
